import { useSelector, useDispatch } from 'react-redux';
import { dashboardActions } from '../../Redux/Dashboard_Slice';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import SidebarItems from './SidebarItems';

const Sidebar = () => {
  const dashboard = useSelector(state => state.dashboard)
  const dispatch = useDispatch()

  return(
    <Box
      component="nav"
      sx={{ 
        width: { lg: dashboard.drawerWidth },
        flexShrink: { lg: 0 }
      }}
      aria-label="mailbox folders"
    >
      <Drawer
        variant="temporary"
        open={dashboard.mobileOpen}
        onTransitionEnd={()=>{
          dispatch(dashboardActions.handleDrawerTransitionEnd())
        }}
        onClose={()=>{
          dispatch(dashboardActions.handleDrawerClose())
        }}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: 'block', lg: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: dashboard.drawerWidth },
        }}
      >
        <SidebarItems />
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: 'none', lg: 'block' },
          '& .MuiDrawer-paper': { 
            boxSizing: 'border-box', 
            width: dashboard.drawerWidth,
            position: 'fixed',
            height: 'calc(100vh - 40px)',
            top: '20px',
            left: '20px',
            border: '1px solid #e0e0e0',
            borderRadius: '12px',
          },
        }}
        open
      >
        <SidebarItems />
      </Drawer>
    </Box>
  )
}

export default Sidebar;